import colors from "vuetify/es5/util/colors";
import { ThemeOptions } from "vuetify/types/services/theme";

export const ubacartTheme: ThemeOptions = {
  themes: {
    light: {
      primary: "#11326C",
      secondary: "#D31875",
      accent: colors.lime.base,
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
    },
  },
};
